export default __webpack_public_path__ + "static/media/main_section4.73a3ab45.jpg";